import { call, put, takeEvery } from "redux-saga/effects";
import { addFileforTeamTaskFail, addFileforTeamTaskSuccess } from "./actions";

import { ADD_FILE_FOR_TASK } from "./actionTypes";

import { onSendingFilesForTeamTask } from "helpers/fakebackend_helper";

import { responseHandler } from "common/CommanFunction";
import showToast from "common/Notification";
const toastTitle = "Task";

function* onSendFileForTask({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onSendingFilesForTeamTask, data);
    yield call(responseHandler, toastTitle, response, addFileforTeamTaskSuccess, addFileforTeamTaskFail, onSuccess, onError);
  } catch (err) {
    onError();
    yield put(addFileforTeamTaskFail(err));
    showToast("error", toastTitle, err);
  }
}

function* TeamSaga() {
  yield takeEvery(ADD_FILE_FOR_TASK, onSendFileForTask);
}

export default TeamSaga;
